var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"app-bold-font d-flex align-start font-20 white--text"},[_vm._v(" Blocked Users ")]),_c('div',{staticClass:"d-flex justify-center mt-15 white--text"},[_vm._v(" No data ")])])
}]

export { render, staticRenderFns }